import cheerio from 'cheerio'

export default function getOrderedLinks (content) {
  const $ = cheerio.load(content)
  let orderedLinks = []
  $('.link').each((index, element) => {
    orderedLinks.push($(element).data('link'))
  })
  return orderedLinks
}


// WEBPACK FOOTER //
// ./src/shared/getOrderedLinks.js